import { render, staticRenderFns } from "./CategoryPoints.vue?vue&type=template&id=780042b8&"
import script from "./CategoryPoints.vue?vue&type=script&lang=js&"
export * from "./CategoryPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports